import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export default ({ servicios = [], max = 0 }) => {
    let n = max || servicios.length;

    let otrosServiciosIcon = null;
    if (servicios.length > n) {
        let otrosServicios = '<ul style="list-style-type: none">';
        servicios.slice(n).forEach(serv => {
            otrosServicios += `<li>${serv.descripcion}</li>`;
        });
        otrosServicios += '</ul>';
        let tooltip = (
            <Popover id="otros_servicios">
                <span dangerouslySetInnerHTML={{ __html: otrosServicios }}/>
            </Popover>
        );

        otrosServiciosIcon = (
            <OverlayTrigger placement="bottom" overlay={tooltip}>
                <i className="mas-servicios fa fa-fw fa-ellipsis-h"/>
            </OverlayTrigger>
        )
    }

    return (
        <div className="lista-servicios">
            {
                servicios.slice(0, n).map(serv => {
                    let tooltip = <Popover id={serv.descripcion}>{serv.descripcion}</Popover>;
                    return (
                        <OverlayTrigger placement="right" overlay={tooltip} key={serv.id}>
                            <i className={"servicio servicio_" + serv.id}/>
                        </OverlayTrigger>
                    )
                })
            }
            {otrosServiciosIcon}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/ListaServicios.js